import { HttpBaseApiWrapper } from 'service/HttpBaseApiWrapper'

import { ILocationResJSON } from '../Locations/LocationsModel'
import { GooglePlace } from '../Locations/Place'
import { Port } from '../Locations/Port'

export interface PlacesData {
  ports: Port[]
  addresses: GooglePlace[]
  locations: ILocationResJSON
}

export type PlacesSearchType = 'address' | 'sea' | 'air' | 'rail'

// TODO check existence of '/place/autocomplete' on backend and delete it

export class PlaceService {
  http: HttpBaseApiWrapper
  constructor(http: HttpBaseApiWrapper) {
    this.http = http

    this.search = this.search.bind(this)
  }

  /**
   * Searches for addresses, airports and seaports at once.
   * Types is a csv of addresses, airports and seaports.
   * filter only applies for seaports and can be either pol or pod.
   */
  search(typesArray: PlacesSearchType[], searchText: string, filter?) {
    let types
    if (typesArray) {
      types = typesArray.join(',')
    } else {
      // Add airports here when airports need to be returned too.
      types = 'addresses,seaports,airports'
    }
    return this.http.get<PlacesData>('/v1/places', {
      params: { types, q: searchText, filter },
    })
  }

  details = (placeId: string) => {
    return this.http.get('/place/details', {
      params: {
        placeid: placeId,
      },
    })
  }
}
